import I18nProvider from './I18nProvider';


export default I18nProvider;
